import React, { useState } from "react";
import { QrReader } from "react-qr-reader";
import { Modal, Button, Spinner } from "react-bootstrap";

const MeetingQRScanner = ({ show, onJoin, onClose }) => {
  const [scanned, setScanned] = useState(false);
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(true);

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="md"
      backdrop="static"
      keyboard={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>Scan Meeting QR Code</Modal.Title>
      </Modal.Header>

      <Modal.Body >
        <p style={{ fontSize: 12, color: "#555" }}>
          Align the QR code inside the camera view.
        </p>
        {loading && (
          <div style={{ textAlign: "center", margin: "20px 0" }}>
            <Spinner animation="border" variant="primary" />
            <p style={{ marginTop: 10 }}>Starting camera...</p>
          </div>
        )}

        <div style={{ display: loading ? "none" : "block" }}>
          <QrReader
            constraints={{ video: { facingMode: "environment" } }}
            scanDelay={500}
            onResult={(res) => {
              if (loading) setLoading(false); 
console.log(res,"resdhgsdjkjkdsdc")
              if (res?.text && !scanned) {
                
                setScanned(true);
                setResult(res.text);
                console.log("Scanned QR:", res.text);
                onJoin(res.text);
              }
            }}
            containerStyle={{ width: "100%" }}
            videoStyle={{ width: "100%", height: "auto", borderRadius: "8px" }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MeetingQRScanner;